// EmployeesLeavesService.js
import httpClient from "@utils/httpClient";

export const getLeaveTypes = async () => {
  try {
    const response = await httpClient.get("/employee/leaves/types");
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error: { message: error.response?.data?.error?.message || error.message || "Failed to fetch Leave Types" }
    };
  }
};

export const getLeaveBalance = async (employeeId) => {
   try {
    const response = await httpClient.get(`/employee/leaves/balance/${employeeId}`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error: { message: error.response?.data?.error?.message || error.message || "Failed to fetch Leave Balance" },
    };
  }
};

export const getPendingLeaves = async (employeeId) => {
  try {
    const response = await httpClient.get(`/employee/leaves/pending/${employeeId}`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error: { message: error.response?.data?.error?.message || error.message || "Failed to fetch Pending Leaves" },
    };
  }
};

export const getApprovedLeaves = async (employeeId) => {
  try {
    const response = await httpClient.get(`/employee/leaves/approved/${employeeId}`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error: { message: error.response?.data?.error?.message || error.message || "Failed to fetch Approved Leaves" },
    };
  }
};

export const getDeclinedLeaves = async (employeeId) => {
  try {
    const response = await httpClient.get(`/employee/leaves/declined/${employeeId}`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      error: { message: error.response?.data?.error?.message || error.message || "Failed to fetch Declined Leaves" },
    };
  }
};

export const createLeaveRequest = async (leaveData) => {
  try {
    const response = await httpClient.post("/employee/leaves/request", leaveData);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: { message: error.response?.data?.error?.message || error.message || "Failed to create Leave Request" },
    };
  }
};

export const withdrawLeave = async (leaveId) => {
  try {
    const response = await httpClient.put(`/employee/leaves/request/${leaveId}/withdraw`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: { message: error.response?.data?.error?.message || error.message || "Failed to withdraw leave" },
    };
  }
};

export const updateLeaveRequest = async (leaveId, leaveData) => {
  try {
    const response = await httpClient.put(`/employee/leaves/request/${leaveId}`, leaveData);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: { message: error.response?.data?.error?.message || error.message || "Failed to update leave request" },
    };
  }
};

export const deletePendingLeave = async (leaveId) => {
  try {
    const response = await httpClient.delete(`/employee/leaves/request/${leaveId}`);
    return {
      success: true,
      data: response.data,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: { message: error.response?.data?.error?.message || error.message || "Failed to delete leave request" },
    };
  }
};